import styled from 'styled-components';
import { common } from 'themes/default';

const {
  buttons: { tertiary }
} = common;

export const FieldContainer = styled.div`
  input[type='radio'] {
    display: none;

    + label {
      width: 30px;
      height: 30px;
      display: inline-flex;
      font-size: 14px;
      background-color: ${tertiary.backgroundColour};
      justify-content: center;
      align-items: center;
      border: 1px solid ${tertiary.borderColour};
      border-radius: 6px;
      cursor: pointer;
      color: ${tertiary.fontColour};
    }

    &:checked + label {
      background-color: ${tertiary.activeBackgroundColour};
      border-color: ${tertiary.activeBorderColour};
      color: ${tertiary.activeFontColour};
    }
  }
`;
